import React from 'react';
import { useWidgetBuilder } from '../context/WidgetBuilderContext';
import { useBuilderLabels } from '../context/BuilderLocaleContext';
function typeLabel(typeId, bt) {
  return bt(`wt_${String(typeId).replace(/-/g, '_')}_label`);
}

export default function SavedWidgetsList() {
  const t = useBuilderLabels();
  const {
    widgetId,
    savedWidgets,
    isUnsavedDraft,
    loadWidgetById,
    startNewWidget,
    removeWidgetById,
  } = useWidgetBuilder();

  const handleDelete = (id) => {
    if (!window.confirm(t('deleteConfirm'))) return;
    removeWidgetById(id);
  };

  return (
    <div className="border-b border-slate-200 bg-slate-50/80 p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wide">{t('myWidgets')}</h2>
        <span className="text-xs text-slate-500">
          {t('savedCount', { count: savedWidgets.length })}
        </span>
      </div>

      <button
        type="button"
        onClick={startNewWidget}
        className="w-full mb-3 py-2 rounded-lg text-sm font-semibold border border-dashed border-slate-300 text-slate-700 hover:border-brand-500 hover:text-brand-700 transition-colors"
      >
        {t('newWidget')}
      </button>

      {savedWidgets.length === 0 ? (
        <p className="text-xs text-slate-500">{t('noSavedYet')}</p>
      ) : (
        <ul className="space-y-2 max-h-40 overflow-y-auto">
          {savedWidgets.map((w) => {
            const active = w.id === widgetId;
            const name = w.config?.name || t('untitled');
            return (
              <li key={w.id}>
                <div
                  className={`flex items-stretch rounded-lg border text-sm transition-colors group ${
                    active
                      ? 'border-brand-500 bg-brand-50 ring-1 ring-brand-500/30'
                      : 'border-slate-200 bg-white hover:border-slate-300'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => loadWidgetById(w.id)}
                    className="flex-1 text-left px-3 py-2 min-w-0"
                  >
                    <span className="font-semibold text-slate-900 truncate block">{name}</span>
                    <span className="text-xs text-slate-500">
                      {typeLabel(w.config?.type, t)} · {w.config?.theme}
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDelete(w.id)}
                    className="shrink-0 px-2 text-slate-400 hover:text-red-600 text-xs opacity-0 group-hover:opacity-100 focus:opacity-100"
                    aria-label={`${t('delete')} ${name}`}
                  >
                    {t('delete')}
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}

      {isUnsavedDraft && (
        <p className="mt-2 text-xs text-slate-500 italic">{t('newDraft')}</p>
      )}
    </div>
  );
}
